module.exports = __webpack_public_path__ + "img/banner-step.b56f6ccb.png";